//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { TrackingId, TrackingIdPrefix } from '@models/TrackingId';

export enum ProductResultsTypes {
  CATALOG_RESULTS = 'catalog-results',
  CATALOG_SUGGESTIONS = 'catalog-suggestions',
  CRAWL_RESULT = 'crawl-result',
  NO_CATALOG = 'no-catalog',
  NO_RESULTS = 'no-results',
}

export const MAX_NUM_CATALOG_SUGGESTIONS = 8;
export const MAX_NUM_PRODUCTS = 40;

export const uiaProductPrefix: TrackingIdPrefix = 'uia-product-';

export const UiaProductTrackingIds = {
  BULK_SELECT_PRODUCT: `${uiaProductPrefix}bulk-select-product`,
  PRODUCT_DESTINATION_URL_LINK: `${uiaProductPrefix}product-destination-url-link`,
  PRODUCT_SEARCH_BAR: `${uiaProductPrefix}product-search-bar`,
  SINGLE_SELECT_PRODUCT: `${uiaProductPrefix}single-select-product`,
} as const satisfies Record<string, TrackingId>;
